import React from "react";
import Loadable from "react-loadable";
import { Switch, Route } from "react-router-dom";
import { NotFound } from "~/views/Errors";
import LoadingSpinner from "~/components/LoadingSpinner";

const StatementView = Loadable({
    loader: () => import("~/views/admin/statement/StatementView"),
    loading: LoadingSpinner
});

export default ({ match }) => (
    <Switch>
        <Route path={`${match.url}/`} render={(props) => (<StatementView mode="balance-sheet" />)} />
        <Route component={NotFound} />
    </Switch>
);